import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getAuth, initializeAuth, indexedDBLocalPersistence, GoogleAuthProvider, OAuthProvider, signInAnonymously } from 'firebase/auth'
import { Capacitor } from '@capacitor/core'

const firebaseConfig = {
  apiKey: 'AIzaSyDAQIO7GnUa1oM-58GSFsDV6x6ac1R4Sac',
  authDomain: 'action-a15be.firebaseapp.com',
  projectId: 'action-a15be',
  storageBucket: 'action-a15be.firebasestorage.app',
  messagingSenderId: '644891256116',
  appId: '1:644891256116:web:cf3fcf8d95deb04f7ab161',
}

const app = initializeApp(firebaseConfig)
export const db = getFirestore(app)
export const auth = Capacitor.isNativePlatform()
  ? initializeAuth(app, { persistence: indexedDBLocalPersistence })
  : getAuth(app)
export const googleProvider = new GoogleAuthProvider()
export const appleProvider = new OAuthProvider('apple.com')

/**
 * Ensure there is a real Firebase auth identity for Firestore writes that the
 * security rules require (`request.auth != null`) — e.g. joining or creating a
 * Party Mode lobby.
 *
 * - If already signed in (Google/Apple OR a previous anonymous session), reuse
 *   that uid — nothing changes for real accounts.
 * - Otherwise sign in anonymously and return the new uid. This is the silent
 *   "guest" path: no prompt, no account creation, it just works in the
 *   background. The session persists, so a returning guest keeps the same uid.
 * - On failure, log and return null so callers can degrade gracefully (show an
 *   error) instead of writing with a fake uid that the rules would reject.
 *
 * NOTE: an anonymous user is a *guest*, not a real account. App.jsx keeps
 * `currentUser` null for anonymous users so account-only guards (ticket store,
 * theme unlocks, etc.) still apply.
 */
export async function ensureAnonymousAuth() {
  if (auth.currentUser) return auth.currentUser.uid
  try {
    const { user } = await signInAnonymously(auth)
    return user.uid
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('[auth] anonymous sign-in failed:', err)
    return null
  }
}

// Direct re-exports of pass-through SDK functions (avoids the
// `import X; export { X }` pattern which can confuse some bundlers).
export {
  signInWithPopup, onAuthStateChanged, signOut, deleteUser,
  reauthenticateWithCredential, reauthenticateWithPopup,
  GoogleAuthProvider, OAuthProvider,
} from 'firebase/auth'
